module.exports = __webpack_public_path__ + "img/Ahorro-N.0cfa7c60.png";